import { render, staticRenderFns } from "./Imagen.vue?vue&type=template&id=d7849d76&"
import script from "./Imagen.vue?vue&type=script&lang=js&"
export * from "./Imagen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports